// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"147":"a69a3d18","380":"e4a3e1e6","853":"b512ec81","904":"e754547e"}[chunkId] + ".chunk.css";
};